import { circleSpinner } from './circle-spinner';
import type { ReactNode } from 'react';

export type IconType = 'circle-spinner';

interface IconDef {
  viewBox: string;
  path: ReactNode;
}

export const icons: Record<IconType, IconDef> = {
  'circle-spinner': circleSpinner,
};

export const validIcons = Object.keys(icons) as IconType[];